module.exports = __webpack_public_path__ + "img/9788963010786.c36fcd4a.jpg";